var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCosmostation = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7287 39.8033L15.4018 27.0999C15.2192 26.7832 15.123 26.4239 15.123 26.0583C15.123 25.6926 15.2192 25.3334 15.4018 25.0167L22.7287 12.3194C22.9114 12.0027 23.1741 11.7397 23.4905 11.5569C23.8069 11.3741 24.1657 11.2778 24.531 11.2778H39.1787C39.544 11.2778 39.903 11.3741 40.2193 11.5569C40.5357 11.7397 40.7984 12.0027 40.981 12.3194L48.3328 25.0291L44.7281 27.1123L38.0019 15.4565H25.7574L19.632 26.0706L26.3581 37.7326L22.7287 39.8033Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4678 46.7176H18.7891C18.4238 46.7176 18.0649 46.6215 17.7485 46.4384C17.4321 46.2558 17.1694 45.9926 16.9868 45.6763L9.66602 32.985L13.2645 30.9019L19.9907 42.5638H32.2291L38.3482 31.9434L31.6283 20.2877L35.2267 18.2046L42.5537 30.9019C42.7363 31.2186 42.8325 31.5778 42.8325 31.9434C42.8325 32.3091 42.7363 32.6683 42.5537 32.985L35.2267 45.6885C35.0471 45.9976 34.7908 46.2545 34.4826 46.4348C34.1744 46.6152 33.8247 46.7126 33.4678 46.7176Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCosmostation);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cosmostation.bbafde2bcac1ca439c830aa9b82b4aa7.svg";